export default __webpack_public_path__ + "static/media/point-of-interest-icon.643b2af7.svg";